// Block type configurations and default values

export const BLOCK_TYPES = {
  BANNER: "banner",
  PRODUCT_GRID: "product-grid",
  CATEGORY_GRID: "category-grid",
  NAVIGATION: "navigation",
  VIDEO: "video",
  ADVERTISEMENT: "advertisement",
  TEXT: "text",
  FLASH_SALE: "flash-sale",
};

export const BLOCK_LIMITS = {
  MAX_BLOCKS_PER_PAGE: 30,
  MAX_BANNERS: 5,
  MAX_PRODUCT_GRIDS: 10,
  MAX_NAVIGATION_BLOCKS: 1,
  MAX_VIDEO_SECTIONS: 2,
  MAX_NAVIGATION_ICONS: 12,
};

export const generateBlockId = () => {
  return `block-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
};

export const getDefaultBlockConfig = (type) => {
  const baseBlock = {
    id: generateBlockId(),
    type,
    order: 0,
    config: {},
  };

  switch (type) {
    case BLOCK_TYPES.BANNER:
      return {
        ...baseBlock,
        config: {
          items: [
            {
              image: "",
              link_data: null,
            },
          ],
          autoplay: true,
          interval: 3000,
          height: 200,
        },
      };
    case BLOCK_TYPES.PRODUCT_GRID:
      return {
        ...baseBlock,
        config: {
          title: "",
          source: "category",
          category_id: null,
          product_ids: [],
          columns: 2,
          limit: 10,
          show_price: true,
        },
      };
    case BLOCK_TYPES.CATEGORY_GRID:
      return {
        ...baseBlock,
        config: {
          title: "",
          columns: 4,
          category_ids: [],
        },
      };
    case BLOCK_TYPES.NAVIGATION:
      return {
        ...baseBlock,
        config: {
          icons: [
            {
              icon: "",
              title: "",
              link_data: null,
            },
          ],
          columns: 5,
        },
      };
    case BLOCK_TYPES.VIDEO:
      return {
        ...baseBlock,
        config: {
          title: "",
          source: "latest",
          video_ids: [],
          layout: "grid",
          limit: 6,
        },
      };
    case BLOCK_TYPES.ADVERTISEMENT:
      return {
        ...baseBlock,
        config: {
          image: "",
          link_data: null,
        },
      };
    case BLOCK_TYPES.TEXT:
      return {
        ...baseBlock,
        config: {
          content: "",
          background_color: "#ffffff",
          padding: 10,
        },
      };
    case BLOCK_TYPES.FLASH_SALE:
      return {
        ...baseBlock,
        config: {
          flash_sale_id: null,
          show_countdown: true,
        },
      };
    default:
      return baseBlock;
  }
};

export const getBlockTypeLabel = (type, i18n) => {
  const labels = {
    [BLOCK_TYPES.BANNER]: i18n.t("customPage.blockTypeBanner"),
    [BLOCK_TYPES.PRODUCT_GRID]: i18n.t("customPage.blockTypeProductGrid"),
    [BLOCK_TYPES.CATEGORY_GRID]: i18n.t("customPage.blockTypeCategoryGrid"),
    [BLOCK_TYPES.NAVIGATION]: i18n.t("customPage.blockTypeNavigation"),
    [BLOCK_TYPES.VIDEO]: i18n.t("customPage.blockTypeVideo"),
    [BLOCK_TYPES.ADVERTISEMENT]: i18n.t("customPage.blockTypeAdvertisement"),
    [BLOCK_TYPES.TEXT]: i18n.t("customPage.blockTypeText"),
    [BLOCK_TYPES.FLASH_SALE]: i18n.t("customPage.blockTypeFlashSale"),
  };
  return labels[type] || type;
};

export const validateBlockLimits = (blocks, newBlockType) => {
  const blockCounts = blocks.reduce((acc, block) => {
    acc[block.type] = (acc[block.type] || 0) + 1;
    return acc;
  }, {});

  // Check total blocks
  if (blocks.length >= BLOCK_LIMITS.MAX_BLOCKS_PER_PAGE) {
    return { valid: false, message: "customPage.errorMaxBlocks" };
  }

  // Check specific block type limits
  switch (newBlockType) {
    case BLOCK_TYPES.BANNER:
      if ((blockCounts[BLOCK_TYPES.BANNER] || 0) >= BLOCK_LIMITS.MAX_BANNERS) {
        return { valid: false, message: "customPage.errorMaxBanners" };
      }
      break;
    case BLOCK_TYPES.PRODUCT_GRID:
      if ((blockCounts[BLOCK_TYPES.PRODUCT_GRID] || 0) >= BLOCK_LIMITS.MAX_PRODUCT_GRIDS) {
        return { valid: false, message: "customPage.errorMaxProductGrids" };
      }
      break;
    case BLOCK_TYPES.NAVIGATION:
      if ((blockCounts[BLOCK_TYPES.NAVIGATION] || 0) >= BLOCK_LIMITS.MAX_NAVIGATION_BLOCKS) {
        return { valid: false, message: "customPage.errorMaxNavigationBlocks" };
      }
      break;
    case BLOCK_TYPES.VIDEO:
      if ((blockCounts[BLOCK_TYPES.VIDEO] || 0) >= BLOCK_LIMITS.MAX_VIDEO_SECTIONS) {
        return { valid: false, message: "customPage.errorMaxVideoSections" };
      }
      break;
  }

  return { valid: true };
};


